import { render, staticRenderFns } from "./invoice-details.vue?vue&type=template&id=57591d6a"
import script from "./invoice-details.vue?vue&type=script&lang=js"
export * from "./invoice-details.vue?vue&type=script&lang=js"
import style0 from "./invoice-details.vue?vue&type=style&index=0&id=57591d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports